import { Page } from "@components/general";
import { getArticles, getPartners, getElasticSearchProducts } from "@utils/services";
import NextFCPage from "@utils/types";
/**
 * @Note
 * import config from "@config/index";
 * the config is not avaliable in the dynamic component
 */
import getConfig from "next/config";
import dynamic from "next/dynamic";

const { publicRuntimeConfig } = getConfig();

// due to nested children is not working on nextjs dynamic, isLoading is required to display circular progress.
const LoadingComponent = () => <Page isLoading />;

const getLandingComponentName = () => {
  if (publicRuntimeConfig.drup) {
    return "drup";
  } else {
    return publicRuntimeConfig.country.toLowerCase();
  }
}
const DynamicComponent = dynamic(import(`../components/landing/${getLandingComponentName()}/index`), {
  loading: LoadingComponent,
  ssr: true,
});

const Landing: NextFCPage = (props) => {
  return <DynamicComponent {...props} />;
};

Landing.getInitialPropsForBot = async (ctx) => {
  try {
    const partners = await getPartners();
    const products = await getElasticSearchProducts({
      bool: {
        should: [
          {
            prefix: {
              "categories.raw": "Cannabis",
            },
          },
        ],
      },
    });
    const articles = await getArticles();

    return { articles, partners, products };
  } catch (error) {
    // @ts-ignore
    nextLogger.error(error);
    return { error };
  }
};

export default Landing;
